/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
(
    function (skyward, $, undefined)
    {
        skyward.stateassessmentsloginbutton = skyward.stateassessmentsloginbutton || {};

        var init = function (selector)
        {
            // Initialize Texas Assessments Login Form
            if ($(selector).find('.stateassessmentsloginbutton').length > 0)
            {
                var element = $(selector).find('.stateassessmentsloginbutton');
                element.on('click', logRedirect);
            }
        };

        var logRedirect = async function (e)
        {
            var loginButton = $(this);

            var accessMode = $('#accessmode').val();
            await $.ajax({
                url: skyward.global.virtualDir + 'Student/Student/LogStateAssessmentsLogin' + accessMode,
                type: 'POST',
                dataType: 'JSON',
                data:
                {
                    studentID: loginButton[0].getAttribute('data-id'),
                    studentidhash: loginButton[0].getAttribute('data-studentidhash'),
                }
            });

            var url = loginButton.attr('data-formaction');

            var formData =
            {
                accesscode: loginButton.attr('data-accesscode'),
                dateofbirth: loginButton.attr('data-dateofbirth'),
                name: loginButton.attr('data-name')
            };

            if (skyward.global.mobileAccess === true) {
                await navigateToExternalUrlRequestOnMobile(url, formData);
            } else {
                var form = skyward.global.createHiddenInputForm(url, formData, true, true);
                skyward.global.submitAndRemoveHiddenInputForm(form);
            }
        };

        async function navigateToExternalUrlRequestOnMobile(url, formData)
        {
            const externalUrlRequestGuid = await $.ajax({
                url: skyward.global.virtualDir + 'SkySys/ExternalUrlRequest/CreateExternalUrlRequest',
                type: 'POST',
                dataType: 'text',
                data:
                {
                    TargetUrl: url,
                    PostData: JSON.stringify(formData)
                }
            });

            const openUrl = skyward.global.virtualDir + 'SkySys/ExternalUrlRequest/HandleExternalUrlRequest?externalUrlRequestGuid=' + encodeURIComponent(externalUrlRequestGuid);
            window.open(openUrl, '_blank');
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);